import React from "react";
import OTPCodeVerify from "../otp/OTPCodeVerify";

const DeleteModalOTP = ({ isOpen, title = "cet élément", onCancel, onConfirm }) => {
  
  return (
    <OTPCodeVerify
      isOpen={isOpen}
      title={`Suppression ${title}`}
      message="Pour des raisons de sécurité, veuillez confirmer cette action par un code OTP envoyé à votre adresse email."
      onCancel={onCancel}
      onVerified={onConfirm}
    />
  );
};

export default DeleteModalOTP;
